import styled from "styled-components";

import { size } from "~/styles/screen";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const HeroSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  background-color: #1f1f1f;
  padding-bottom: 40px;
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const HeroContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HeroCenteredSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  padding: 1.5rem;
  line-height: 1.125;

  @media screen and (max-width: ${size.small}) {
    padding: 0;
  }
`;

export const HeroH1 = styled.h1`
  font-size: 52px;
  text-align: center;
  font-weight: 800;
  font-family: "Roboto Slab";
  color: white;
  margin-top: 50px;
`;

export const InputSection = styled.div`
  margin-top: 30px;
  display: flex;
  width: 80%;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${size.small}) {
    width: 100%;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 50px;
  box-shadow: inset 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  outline: none;
  padding-left: 20px;
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 16px;
  line-height: 19.5px;

  &::placeholder {
    color: #8e8e8e;
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 16px;
    line-height: 19.5px;
  }
`;

export const SearchContent = styled.div`
  margin: 40px auto 70px;
  display: flex;
  max-width: 1000px;
  width: 90%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const VaspCardContainer = styled.div`
  width: 60%;
`;

export const Footer = styled.div`
  margin-top: 80px;
  align-self: center;
  background: #1f1f1f;
  width: 100%;
  height: 50vh;
`;
